import { apiPostJson } from '$lib/proxy/apiProxy'

export const getNextInvoiceNumber = async (num: string): Promise<string> => {



	const jsonData = await apiPostJson('/invoices/next_number', {
		number: num
	})
	if (!jsonData) return ''
	if (jsonData?.error) return ''

	return jsonData.next_number
}
